const filterByString = (searchString, otherFilter) => ([id, course]) => {
  const fields = [
    course.title,
    course.company || '',
    course.cancelled ? 'cancelled' : '',
    Object.values(course.attendees || {})
      .map(
        attendee => attendee.firstName + attendee.lastName + attendee.company
      )
      .join(' ')
  ]
  return (
    fields.reduce(
      (match, value) =>
        match
          ? match
          : String(value)
              .toLowerCase()
              .includes(searchString.toLowerCase()),
      false
    ) && otherFilter(course)
  )
}

export default filterByString



// WEBPACK FOOTER //
// ./src/views/CourseList/Main/helpers/filter-by-string.js